import {apiGet} from './client';

// Живой блог из админки. Список: [{slug, title, date, excerpt}].
export function fetchBlogArticles() {
    return apiGet('/celebs/blog/articles');
}

// Статья целиком + «Читайте также» (related) + номер отзыва (review_index).
// 404 — статьи нет (err.status === 404).
export function fetchBlogArticle(slug) {
    return apiGet(`/celebs/blog/articles/${encodeURIComponent(slug)}`);
}
